export var getFirstFourItems = function getFirstFourItems(items) {
  return items.slice(0, 4);
};